import { getStorefrontOrigin } from '@/features/cms/preview/sfOrigin';

/**
 * QA-129 (ID129) — BO 상품 목록 썸네일 클릭 시 이동할 storefront 공개 상품 페이지 URL.
 *
 * storefront 공개 PDP 라우트는 `/products/[productId]` (src/app/products/[productId]).
 * origin 은 cms preview 와 동일한 {@link getStorefrontOrigin}(VITE_SF_ORIGIN + dev 기본) 재사용.
 * productId 는 URL path 로만 쓰이며(인코딩) 화면 텍스트로는 노출하지 않는다.
 */
export const buildStorefrontProductUrl = (productId: string): string =>
  `${getStorefrontOrigin()}/products/${encodeURIComponent(productId)}`;
